module.exports = __webpack_public_path__ + "img/c08_buildingtechindrasgift_Normal_ua.41f0d217.webp";